<template>
  <div class="timeline2">
    <h4 style="margin-top:20px;">人物列表</h4>
    <el-select
      v-model="people_ids"
      multiple placeholder="请选择"
      style="margin-top:10px;width: 300px">
      <el-option
        v-for="item in peoples"
        :key="item.id"
        :label="item.name"
        :value="item.id"
        clearable>
      </el-option>
    </el-select>
    <h4 style="margin-top:20px;">时间线图片</h4>
    <div class="upload">
      <div class="logo" v-if="image">
        <img :src="image">
      </div>
      <el-upload
        :action="this.$store.state.baseurl+'/image'"
        accept="image/*"
        :headers="headers"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload"
        name="image"
        :show-file-list="false">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
      </el-upload>
    </div>
    <h4 style="margin-top:30px;">分享图</h4>
    <div class="upload">
      <div class="logo" v-if="poster">
        <img :src="poster">
      </div>
      <el-upload
        :action="this.$store.state.baseurl+'/image'"
        accept="image/*"
        :headers="headers"
        :on-success="uploadSuccess2"
        :on-error="uploadError"
        :before-upload="beforeUpload"
        name="image"
        :show-file-list="false">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">jpg/gif/png文件</div>
      </el-upload>
    </div>
    <el-button type="primary" @click="onSave">保 存</el-button>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
import { getToken } from '@/utils/auth'
export default {
  name: 'timeline2',
  components: {
    UploadImg
  },
  data () {
    return {
      headers: {
        Authorization: getToken()
      },
      people_ids: [],
      image: '',
      poster: '',
      peoples: []
    }
  },
  created () {
    request({
      url: '/ui/movie/timeline-content'
    }).then(res => {
      this.image = res.data.content.image
      this.poster = res.data.content.poster
      this.people_ids = res.data.content.people_ids || []
    })
    request({
      url: '/movie/people'
    }).then(res => {
      this.peoples = res.data.list
    })
  },
  methods: {
    onSave () {
      request({
        url: '/ui/movie/timeline-content',
        method: 'put',
        data: {
          image: this.image,
          poster: this.poster,
          people_ids: this.people_ids
        }
      }).then(res => {
        this.$message.success('保存成功！')
      })
    },
    uploadSuccess (response, file, fileList) {
      let url = response.data.image.url
      this.image = url
      this.$myLoading.hide()
    },
    uploadSuccess2 (response, file, fileList) {
      let url = response.data.image.url
      this.poster = url
      this.$myLoading.hide()
    },
    uploadError (e) {
      this.$myLoading.hide()
      this.$message.error('上传失败，网络不佳!')
    },
    beforeUpload (file) {
      this.$myLoading.show('上传中')
    }
  }
}
</script>
<style lang="less" scoped>
.upload {
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  align-items: flex-end;
  .logo {
    height: 100px;
    min-width: 100px;
    margin-right: 15px;
    img {
      height: 100px;
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/timeline2.vue